module.exports = __webpack_public_path__ + "static/media/triobanner.cd32515e.png";